import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const MissionSection = () => {
  const partnerLogos = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jEgZ6T3TX4jyEE1EJEmFq1/IMG_1253_2.jpg',
    alt: 'Cared Solutions Logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ou9v33rPa1ES4yCeCquWyx/IMG_1252_2.jpg',
    alt: 'Intervention Point Logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eXdYTGpuu8Ets6x6fvscQc/Copy_of_Untitled_Design_5.png.png',
    alt: 'Max Life Logo'
  }];
  const mediaLogos = [{
    name: 'FOX',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tN5M1y4U7Y55CgcVXU85s5/IMG_2128.jpg'
  }, {
    name: 'ABC 4',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tTDJzNeit3KV2mX63LgPaq/IMG_2133.jpg'
  }, {
    name: 'KTLA 5',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nYrKvfrwUB9Cprg8in1P3t/IMG_2132.jpg'
  }, {
    name: 'PR Newswire',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agxRyAADpErBvRL8UkggXj/IMG_2131.jpg'
  }, {
    name: 'Yahoo!',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5drNs64uHAFUid7vDqpbVP/IMG_2130.jpg'
  }, {
    name: 'Associated Press',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wLPXzDywitRgbSDswRhzKh/IMG_2139.jpg'
  }, {
    name: 'NBC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r286LkD3jE3DyV8mJmBNUv/IMG_2143_2.jpg'
  }, {
    name: 'Stu News Newport',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kzTvBygzEQP7i6rPgDGeWX/IMG_2142.jpg'
  }, {
    name: 'The Orange County Register',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hFr54khZD1Yb6xwFKf4E1T/IMG_2141.jpg'
  }, {
    name: 'CBS',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sPvZEfuN3ULvt8bTZAUedR/IMG_2140.jpg'
  }, {
    name: 'Forbes',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8vB1dgqog5SzqUG4Fu1qAc/IMG_2144.jpg'
  }, {
    name: 'ABC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ceZ6VmLkV5HKg8aUvWrLnc/IMG_2152.jpg'
  }, {
    name: 'FOX Business Network',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wckjrc1GtHFZRL89YkpRqU/IMG_2150.jpg'
  }, {
    name: 'USA Today',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2DdZhuXvM1yQNuRXAM99B4/IMG_2145.jpg'
  }, {
    name: 'Forbes (New)',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1oS6UZbX5R2nFsDsEk9SF9/IMG_2144.jpg'
  }, {
    name: 'ABC (New)',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/woBP8xxbhf694saW8BGK2D/IMG_2152.jpg'
  }, {
    name: 'FOX Business Network (New)',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gR7ucARTVA6H7DTSmY6Gwb/IMG_2150.jpg'
  }, {
    name: 'USA Today (New)',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iBXr3pmcveG7p1RMpraWa5/IMG_2145.jpg'
  }, {
    name: 'NBC (New)',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r286LkD3jE3DyV8mJmBNUv/IMG_2143_2.jpg'
  }, {
    name: 'FOX',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tN5M1y4U7Y55CgcVXU85s5/IMG_2128.jpg'
  }, {
    name: 'ABC 4',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tTDJzNeit3KV2mX63LgPaq/IMG_2133.jpg'
  }, {
    name: 'KTLA 5',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nYrKvfrwUB9Cprg8in1P3t/IMG_2132.jpg'
  }, {
    name: 'PR Newswire',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agxRyAADpErBvRL8UkggXj/IMG_2131.jpg'
  }, {
    name: 'Yahoo!',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5drNs64uHAFUid7vDqpbVP/IMG_2130.jpg'
  }];
  // Highlighted media logos array with the latest uploads
  const highlightedMediaLogos = [{
    name: 'Forbes',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a72hgB2nShaHU7YKvyyapQ/IMG_2144.jpg'
  }, {
    name: 'FOX Business Network',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pWMbgV4q7ZUotqzJp9ozjA/IMG_2150.jpg'
  }, {
    name: 'USA Today',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3Ppmpp7AhRSoFvNUhGEWXZ/IMG_2145.jpg'
  }, {
    name: 'NBC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r286LkD3jE3DyV8mJmBNUv/IMG_2143_2.jpg'
  },
  // Duplicate for continuous scrolling
  {
    name: 'Forbes',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a72hgB2nShaHU7YKvyyapQ/IMG_2144.jpg'
  }, {
    name: 'USA Today',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3Ppmpp7AhRSoFvNUhGEWXZ/IMG_2145.jpg'
  }, {
    name: 'NBC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/r286LkD3jE3DyV8mJmBNUv/IMG_2143_2.jpg'
  }];
  // New additional media logos array
  const additionalMediaLogos = [{
    name: 'Los Angeles Times',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/weDTqEq4q1EFQ1mUTmpKJZ/IMG_2135.jpg'
  }, {
    name: 'CBS',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wAMPMMM48LHAjnGGFD6Dp3/IMG_2140.jpg'
  }, {
    name: 'Associated Press',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/x1qUqTy1uxejExNyPyfu3A/IMG_2139.jpg'
  }, {
    name: 'VoyageLA',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdPAcm3uzKsxEWCrr6SPBK/IMG_2138.jpg'
  }, {
    name: 'Modern Luxury',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kao6qwu3ox743vUCWPrzH7/IMG_2136.jpg'
  },
  // Duplicate for continuous scrolling
  {
    name: 'Los Angeles Times',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/weDTqEq4q1EFQ1mUTmpKJZ/IMG_2135.jpg'
  }, {
    name: 'CBS',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wAMPMMM48LHAjnGGFD6Dp3/IMG_2140.jpg'
  }, {
    name: 'Associated Press',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/x1qUqTy1uxejExNyPyfu3A/IMG_2139.jpg'
  }, {
    name: 'VoyageLA',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdPAcm3uzKsxEWCrr6SPBK/IMG_2138.jpg'
  }, {
    name: 'Modern Luxury',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kao6qwu3ox743vUCWPrzH7/IMG_2136.jpg'
  }];
  // New media logos array with the latest uploads
  const newMediaLogos = [{
    name: 'Orange County Business Journal',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e6VdrQgqsv8bFzmdmx2KsR/IMG_2134_2.jpg'
  }, {
    name: 'Stu News Newport',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kUe37dnrJxVYAtznfktvp8/IMG_2142_2.jpg'
  }, {
    name: 'The Orange County Register',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k9BZerrg5Tz27rAK7hGrxU/IMG_2141_2.jpg'
  }, {
    name: 'ABC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u19xHEm7814BCegLJiPdpK/Untitled_design_2.png.png'
  },
  // Duplicate for continuous scrolling
  {
    name: 'Orange County Business Journal',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e6VdrQgqsv8bFzmdmx2KsR/IMG_2134_2.jpg'
  }, {
    name: 'Stu News Newport',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kUe37dnrJxVYAtznfktvp8/IMG_2142_2.jpg'
  }, {
    name: 'The Orange County Register',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k9BZerrg5Tz27rAK7hGrxU/IMG_2141_2.jpg'
  }, {
    name: 'ABC',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u19xHEm7814BCegLJiPdpK/Untitled_design_2.png.png'
  }];
  return <section className="w-full py-20 bg-gradient-to-b from-white to-gold-50" data-id="element-156">
      <div className="container mx-auto px-4" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          {/* WHO IS LEGACY LAB FOR? */}
          <div className="mb-16 text-center" data-id="element-159">
            <h2 className="text-3xl sm:text-4xl font-bold mb-8 relative" data-id="element-160">
              <span className="text-gold-600" data-id="element-161">⚡</span> WHO IS{' '}
              <span className="text-gradient" data-id="element-162">LEGACY LAB</span> FOR?
            </h2>
            <div className="mb-8 text-lg text-gray-700" data-id="element-163">
              <p className="mb-4" data-id="element-164">You already make moves.</p>
              <p className="mb-4" data-id="element-165">You already lead people.</p>
              <p className="mb-8" data-id="element-166">
                But you know there's another level — and it's not accessible to
                everyone.
              </p>
            </div>
            <div className="bg-white shadow-md border border-gold-200 rounded-xl p-6 mb-6 text-center" data-id="element-167">
              <p className="font-semibold mb-4 text-lg text-gray-800" data-id="element-168">
                This is for you if:
              </p>
              <ul className="space-y-3" data-id="element-169">
                {["You've built success… but not sustainable wealth", "You're tired of surface-level conversations about money", 'You want vetted relationships, not just followers', 'You need structure, capital, and strategy to match your potential'].map((item, i) => <li key={i} className="flex items-center justify-center" data-id="element-170">
                    <CheckIcon className="h-5 w-5 mr-3 flex-shrink-0 text-gold-600" data-id="element-171" />
                    <span className="text-gray-700" data-id="element-172">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-8 text-lg" data-id="element-173">
              <p className="mb-2 text-gray-700" data-id="element-174">This is not for the curious.</p>
              <p className="font-semibold text-gradient" data-id="element-175">
                This is for the called.
              </p>
            </div>
          </div>
          {/* Divider */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent my-12" data-id="element-176"></div>
          {/* WHY THIS, WHY NOW? */}
          <div className="mb-16 text-center" data-id="element-177">
            <h2 className="text-3xl sm:text-4xl font-bold mb-8 relative" data-id="element-178">
              <span className="text-gold-600" data-id="element-179">🔥</span> WHY THIS,{' '}
              <span className="text-gradient" data-id="element-180">WHY NOW?</span>
            </h2>
            <div className="mb-8 text-lg text-gray-700" data-id="element-181">
              <p className="mb-4" data-id="element-182">Because doing it alone got you here.</p>
              <p className="mb-8" data-id="element-183">But it won't get you there.</p>
            </div>
            <div className="bg-white shadow-md border border-gold-200 rounded-xl p-6 mb-6 text-center" data-id="element-184">
              <p className="font-semibold mb-4 text-lg text-gray-800" data-id="element-185">
                Legacy Lab gives you direct access to:
              </p>
              <ul className="space-y-3" data-id="element-186">
                {['Proven frameworks to grow and protect wealth', 'Strategic partnerships and referrals that open capital and collaboration', 'A private circle of top-tier thinkers, earners, and builders', 'Compounding tools that work while you sleep'].map((item, i) => <li key={i} className="flex items-center justify-center" data-id="element-187">
                    <span className="text-gold-600 mr-3" data-id="element-188">•</span>
                    <span className="text-gray-700" data-id="element-189">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-lg" data-id="element-190">
              <div className="flex items-center" data-id="element-191">
                <XIcon className="h-5 w-5 mr-2 text-red-500" data-id="element-192" />
                <span className="text-gray-700" data-id="element-193">No fluff. No gatekeeping.</span>
              </div>
              <div className="flex items-center" data-id="element-194">
                <CheckIcon className="h-5 w-5 mr-2 text-gold-600" data-id="element-195" />
                <span className="text-gray-700" data-id="element-196">
                  Just access, strategy, and execution.
                </span>
              </div>
            </div>
          </div>
          {/* Divider */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent my-12" data-id="element-197"></div>
          {/* WHAT YOU GAIN INSIDE */}
          <div className="text-center" data-id="element-198">
            <h2 className="text-3xl sm:text-4xl font-bold mb-8 relative" data-id="element-199">
              <span className="text-gold-600" data-id="element-200">🧠</span> WHAT YOU{' '}
              <span className="text-gradient" data-id="element-201">GAIN INSIDE</span>
            </h2>
            <div className="bg-white shadow-md border border-gold-200 rounded-xl p-6 mb-10 text-center" data-id="element-202">
              <ul className="space-y-4" data-id="element-203">
                {['A 4-part Wealth Ecosystem: Credit. Cash. Cashflow. Capital.', 'Strategy Sessions with Advisors, Investors, and Funders', 'Tools and Templates to Implement What the Wealthy Actually Do', "A Brotherhood and Sisterhood of Builders Who Don't Miss"].map((item, i) => <li key={i} className="flex items-center justify-center" data-id="element-204">
                    <CheckIcon className="h-5 w-5 mr-3 flex-shrink-0 text-gold-600" data-id="element-205" />
                    <span className="text-gray-700" data-id="element-206">{item}</span>
                  </li>)}
              </ul>
            </div>
            <p className="text-xl sm:text-2xl font-medium text-gradient mb-16" data-id="element-207">
              This is where financial theory becomes movement.
            </p>
            {/* Premier Partnerships Section */}
            <div className="text-center mt-16" data-id="element-208">
              <h3 className="text-3xl sm:text-4xl font-bold mb-12" data-id="element-209">
                Premier <span className="text-gradient" data-id="element-210">Partnerships</span>
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto stagger-container" data-id="element-211">
                {partnerLogos.slice(0, 4).map((logo, index) => <div key={index} className="flex items-center justify-center p-4 rounded-lg fade-item bg-white border border-gray-200 hover:border-gold-500 transition-all duration-300 transform hover:-translate-y-2 observer-element shadow-sm" style={{
                transitionDelay: `${index * 0.15}s`
              }} data-id="element-212">
                    <div className="w-[160px] h-[100px] flex items-center justify-center" data-id="element-213">
                      <img src={logo.src} alt={logo.alt} className="max-w-full max-h-full object-contain" data-id="element-214" />
                    </div>
                  </div>)}
                <div className="w-full flex flex-wrap justify-center gap-8" data-id="element-215">
                  {partnerLogos.slice(4).map((logo, index) => {})}
                </div>
              </div>
              {/* Featured In Media Section */}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default MissionSection;